module.exports = __webpack_public_path__ + "img/history.3f6f4ac3.png";